import api from "../../config/apiConfig";

const updateDemat = async (data: FormData) => {
    const accessToken = localStorage.getItem("accessToken");
    const response = await api.post("/user/updateDemat", data, {
        headers: {
            Authorization: accessToken,
        },
    });
    return response.data;
}

const dematService = { updateDemat };
export default dematService;